import apiUrl from '../../../constants'
import user_tracker from '../../../usertracker'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import moment from 'moment'
import { BasicSelect,ModelSelect} from 'vue-search-select';

export default {
  name: 'hubparentbagginghubdetails',
  components: {
    BasicSelect,
    ModelSelect,
    VueElementLoading,
    Multiselect
  },
  props: [],
  data() {
    return {
      sourceHubId: null,
      listSourceHubNameData: [],
      destinationhub: {},
      destinationhublist: [],
      allHublist: [],
      listDestHubNameData: [],
      HubArr: [],
      destData: [],
      connectionDestList: [],
      addmodalShow: false,
      checkAllHub:false,
      totalmappedhubs: 0,
      connDestLoading:false,
      useremail:'',
      sourceHubLoading:'',
      modelArr: [],
      checked:[],
      userData:[],
      destinationhubArr:[]
    }
  },
  computed: {

  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes             = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext         = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail        = JSON.parse(plaintext);
    this.useremail        = userdetail[0].email;
    this.userData = userdetail;
    this.getHubList();
  },
  methods: {
    getHubList(filter) {
      this.sourceHubLoading = 'Loading Hub...'
      this.listSourceHubNameData = [];
      this.sourceHubId = null;
			this.destinationhub= {};

			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/dropdwon/list',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
        .then(result => {
          if (result.data.ResultCode == 100) {
						this.listSourceHubNameData = result.data.ResponseData.map(i => ({ text:i.HubName +' ('+i.HubID+')', value:i.HubID }));
						this.destinationhublist = result.data.ResponseData.map(i => ({ text:i.HubName +' ('+i.HubID+')', value:i.HubID }));
						this.allHublist = result.data.ResponseData.map(i => ({ text:i.HubName +' ('+i.HubID+')', value:i.HubID }));
          }
          this.sourceHubLoading = '';
        }, error => {
          this.sourceHubLoading = '';
          console.error(error)
        })
    },

		// SelectSourceHub() {
		// 	this.destinationh= {};
		// 	var a = this.sourceHubId.value
		// 	this.destinationhublist = this.allHublist.filter(function(el) {
		// 		return el.value != a
		// 	});
		// },
    selectdestinationhub(selected){
    this.destinationhub = selected
    },
    SelectSourceHub(selected) {
  if (!selected) {
    this.sourceHubId = null;
    this.destinationhublist = this.allHublist;  // or []
    return;
  }
  this.sourceHubId = selected;
  const a = selected.value;
  this.destinationhublist = this.allHublist.filter(el => el.value !== a);
},


    onSubmit: function() {
      console.log("source",this.sourceHubId)
      let hasError = false;

    // SOURCE HUB
    if (!this.sourceHubId || !this.sourceHubId.value) {
      console.log("ji")
      document.getElementById("source").innerHTML =
        'The Source Hub Name field is required.';
      hasError = true;
    } else {
      document.getElementById("source").innerHTML = '';
    }
      this.$validator.validateAll()
        .then((result) => {
          if (Object.keys(this.destinationhub).length <= 0 || Object.keys(this.sourceHubId).length <= 0){
            document.getElementById("dest").innerHTML= (Object.keys(this.destinationhub).length <= 0) ? 'The Destination Hub Name field is required.':'';
            document.getElementById("source").innerHTML= (Object.keys(this.sourceHubId).length <= 0) ? 'The Source Hub Name field is required.':'';
            return false;
          }

          if (!result) {
            console.log('errors exist', this.errors); return false;
          } else {
            this.getDestinationsByConnection();
          }
        }).catch(() => {
          console.log('parent search errors exist', this.errors);
        });
    },

    resetForm() {
      this.sourceHubId= {},
      this.destinationhub= {},
      this.HubArr= [],
      this.destData= [],
      this.connectionDestList= [],
      this.modelArr= [],
      this.checked= [],
      this.addmodalShow= false,
      this.checkAllHub= false,
      this.totalmappedhubs= 0,
      this.sourceHubLoading= '',
      this.connDestLoading= false,
      document.getElementById("dest").innerHTML='',
      document.getElementById("source").innerHTML=''
      this.$validator.reset();
      this.sourceHubId = null;
      this.destinationhubArr=[]
    },

    closeStatusModal() {
      this.addmodalShow = false
    },

    getDestinationsByConnection() {
      if (Object.keys(this.sourceHubId).length <= 0 || Object.keys(this.destinationhub).length <= 0) { return false; }

      this.connDestLoading    = true;
      this.destData           = [];
      this.HubArr             = [];
      this.totalmappedhubs    = 0;
      this.checkAllHub        = false;
      this.modelArr           = [];
      this.checked            = [];

      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + "getallocatedChildBagToParentDestination_V1?originHubId="+this.sourceHubId.value+"&masterBagHubId="+this.destinationhub.value,
          headers: {
            'Authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            let j=0; let list=[]; let dlist=[];
            let hData = result.data.ResponseData;
            for (var i = 0; i < hData.length; i++) {
              if(j<4){
                list.push({
                  hubId:hData[i].HubID,
                  hubName:hData[i].HubName
                });
              }else{
                dlist.push(list);
                list=[]
                list.push({
                  hubId:hData[i].HubID,
                  hubName:hData[i].HubName
                });
                j=0;
              }
              j++;

              if(hData[i].isHubSelected==true){
                this.modelArr.indexOf(hData[i].HubID) === -1 ? this.modelArr.push(hData[i].HubID):'';
                this.checked[hData[i].HubID] = true;
              }

              this.destData.push({
                hubId:hData[i].HubID,
                hubName:hData[i].HubName
              });
            }
            dlist.push(list);
            this.connectionDestList = dlist;

            this.totalmappedhubs  = result.data.TotalCount;
            if(this.modelArr.length == this.destData.length) this.checkAllHub = true;
          }else{
            this.$alertify.error(result.data.ReturnMessage, "", "error");
          }
          this.connDestLoading=false;
        }, error => {
          this.connDestLoading=false;
          console.error(error)
        })
    },

    checkHub() {
      if(typeof InstallTrigger !== 'undefined' == true){ this.checkAllHub = !this.checkAllHub; }
      this.modelArr = [];

      if (this.checkAllHub) {
        for (var i = 0; i < this.destData.length; i++) {
          this.checked[this.destData[i].hubId]=true;
        }

        this.modelArr = [...new Set(this.destData.map(a => a.hubId))];
      }else{
         this.checked=[];
      }
    },

    updateCheckDest(event){
     this.checked[event.target.id] = event.target.checked;

     if(event.target.checked==false){
       this.modelArr = this.modelArr.filter(el => el != event.target.id)

     }else{
       this.modelArr.indexOf(event.target.id) === -1 ? this.modelArr.push(parseInt(event.target.id)):'';
     }

     this.checkAllHub = (this.destData.length === this.modelArr.length) ? true : false;
	 },


    onSubmitHub: function(elem) {
     this.$validator.validateAll('hubsave').then((result) => {
       if (result) {
         if (Object.keys(this.sourceHubId).length <= 0 || Object.keys(this.destinationhub).length <= 0 || this.modelArr.length <= 0) {
           this.$alertify.error('Hub selection or source/ destination hub should not be empty!'); return false;
         }else{
           this.addmodalShow = true
         }
       }else{
         return false;
       }
     }).catch(() => {});
   },

    mapMultipleHubsToConnection() {
     this.connDestLoading = true;
     this.HubArr = this.destData.filter((elem) => this.modelArr.find((el) => elem.hubId == el));
		 this.input = {
			 masterBagHubId: this.destinationhub.value,
			 masterBagHubName: this.destinationhub.text,
			 originHubId: this.sourceHubId.value,
			 originHubName: this.sourceHubId.text,
			 hubIdAndHubName: this.HubArr,
			 createdBy: this.useremail
		 }
     axios({
         method: 'POST',
         'url': apiUrl.api_url_hubops + "allocatedChildBagDestinationToParentBagDestination_V1",
         'data': this.input,
         headers: {
           'Authorization': "authkey xB84JJ89Hd25"
         }
       })
       .then(result => {
         if (result.data.ResultCode == 100) {
           this.$alert(result.data.ReturnMessage, "", "success");
           user_tracker.checkUserIP(this.userData[0], "AddEditHubParentBagDestinationIn-HubDetails", this.$route.path , this.input);
					 this.getDestinationsByConnection();
         } else {
           this.$alert(result.data.ReturnMessage, "", "error");
         }
         this.connDestLoading = false;
       }, error => {
         this.connDestLoading = false;
         console.error(error)
       })
   },

    takeAction() {
     this.mapMultipleHubsToConnection();
   },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/hubparentbagginghubdetails/hubparentbagginghubdetails.component.js